export const KanaList = [
  // Seion (清音)
  {id: 1, hiragana: 'あ', katakana: 'ア', romaji: 'a', color: '#FFCCCC', category: 'seion'},
  {id: 2, hiragana: 'い', katakana: 'イ', romaji: 'i', color: '#CCFFCC', category: 'seion'},
  {id: 3, hiragana: 'う', katakana: 'ウ', romaji: 'u', color: '#CCCCFF', category: 'seion'},
  {id: 4, hiragana: 'え', katakana: 'エ', romaji: 'e', color: '#FFFFCC', category: 'seion'},
  {id: 5, hiragana: 'お', katakana: 'オ', romaji: 'o', color: '#FFCCFF', category: 'seion'},
  {id: 6, hiragana: 'か', katakana: 'カ', romaji: 'ka', color: '#FF9999', category: 'seion'},
  {id: 7, hiragana: 'き', katakana: 'キ', romaji: 'ki', color: '#99FF99', category: 'seion'},
  {id: 8, hiragana: 'く', katakana: 'ク', romaji: 'ku', color: '#9999FF', category: 'seion'},
  {id: 9, hiragana: 'け', katakana: 'ケ', romaji: 'ke', color: '#FFFF99', category: 'seion'},
  {id: 10, hiragana: 'こ', katakana: 'コ', romaji: 'ko', color: '#FF99FF', category: 'seion'},

  // Dakuon (濁音)
  {id: 101, hiragana: 'が', katakana: 'ガ', romaji: 'ga', color: '#FF5555', category: 'dakuon'},
  {id: 102, hiragana: 'ぎ', katakana: 'ギ', romaji: 'gi', color: '#55FF55', category: 'dakuon'},
  {id: 103, hiragana: 'ぐ', katakana: 'グ', romaji: 'gu', color: '#5555FF', category: 'dakuon'},
  {id: 104, hiragana: 'げ', katakana: 'ゲ', romaji: 'ge', color: '#FFFF55', category: 'dakuon'},
  {id: 105, hiragana: 'ご', katakana: 'ゴ', romaji: 'go', color: '#FF55FF', category: 'dakuon'},

  // Handakuon (半濁音)
  {id: 201, hiragana: 'ぱ', katakana: 'パ', romaji: 'pa', color: '#FF8888', category: 'handakuon'},
  {id: 202, hiragana: 'ぴ', katakana: 'ピ', romaji: 'pi', color: '#88FF88', category: 'handakuon'},
  {id: 203, hiragana: 'ぷ', katakana: 'プ', romaji: 'pu', color: '#8888FF', category: 'handakuon'},
  {id: 204, hiragana: 'ぺ', katakana: 'ペ', romaji: 'pe', color: '#FFFF88', category: 'handakuon'},
  {id: 205, hiragana: 'ぽ', katakana: 'ポ', romaji: 'po', color: '#FF88FF', category: 'handakuon'},

  // Yo-on (拗音)
  {id: 301, hiragana: 'きゃ', katakana: 'キャ', romaji: 'kya', color: '#FFAACC', category: 'yo-on'},
  {id: 302, hiragana: 'きゅ', katakana: 'キュ', romaji: 'kyu', color: '#AAFFAA', category: 'yo-on'},
  {id: 303, hiragana: 'きょ', katakana: 'キョ', romaji: 'kyo', color: '#AAAFFF', category: 'yo-on'},
  {id: 304, hiragana: 'ぎゃ', katakana: 'ギャ', romaji: 'gya', color: '#FFAA99', category: 'yo-on'},
  {id: 305, hiragana: 'ぎゅ', katakana: 'ギュ', romaji: 'gyu', color: '#99FFAA', category: 'yo-on'},
  {id: 306, hiragana: 'ぎょ', katakana: 'ギョ', romaji: 'gyo', color: '#99AAFF', category: 'yo-on'},
  {id: 307, hiragana: 'しゃ', katakana: 'シャ', romaji: 'sha', color: '#FFAAAA', category: 'yo-on'},
  {id: 308, hiragana: 'しゅ', katakana: 'シュ', romaji: 'shu', color: '#AAFFAA', category: 'yo-on'},
  {id: 309, hiragana: 'しょ', katakana: 'ショ', romaji: 'sho', color: '#AAAAFF', category: 'yo-on'},
  {id: 310, hiragana: 'ちゃ', katakana: 'チャ', romaji: 'cha', color: '#FFAAFF', category: 'yo-on'},
  {id: 311, hiragana: 'ちゅ', katakana: 'チュ', romaji: 'chu', color: '#AAFFCC', category: 'yo-on'},
  {id: 312, hiragana: 'ちょ', katakana: 'チョ', romaji: 'cho', color: '#AACCFF', category: 'yo-on'},
  {id: 313, hiragana: 'にゃ', katakana: 'ニャ', romaji: 'nya', color: '#FFCCAA', category: 'yo-on'},
  {id: 314, hiragana: 'にゅ', katakana: 'ニュ', romaji: 'nyu', color: '#CCFFAA', category: 'yo-on'},
  {id: 315, hiragana: 'にょ', katakana: 'ニョ', romaji: 'nyo', color: '#CCAFFF', category: 'yo-on'},
  {id: 316, hiragana: 'ひゃ', katakana: 'ヒャ', romaji: 'hya', color: '#FFCCCC', category: 'yo-on'},
  {id: 317, hiragana: 'ひゅ', katakana: 'ヒュ', romaji: 'hyu', color: '#CCFFCC', category: 'yo-on'},
  {id: 318, hiragana: 'ひょ', katakana: 'ヒョ', romaji: 'hyo', color: '#CCCCFF', category: 'yo-on'},
  {id: 319, hiragana: 'みゃ', katakana: 'ミャ', romaji: 'mya', color: '#FFCC99', category: 'yo-on'},
  {id: 320, hiragana: 'みゅ', katakana: 'ミュ', romaji: 'myu', color: '#99FFCC', category: 'yo-on'},
  {id: 321, hiragana: 'みょ', katakana: 'ミョ', romaji: 'myo', color: '#99CCFF', category: 'yo-on'}
];
